// Required for dev hot reload
if (import.meta.hot) {

    import.meta.hot.accept(() => {
      console.log("HMR")
    });
}

import Products from './components/product-search';
document.addEventListener('DOMContentLoaded', Products, false);